import React, { useEffect } from 'react';
import './Clients.css';
import type { User } from '../../types/Auth';
import { useAuth } from '../../contexts/AuthProvider/AuthProvider';
import {
  ConsultationDetails,
  Consultations,
} from '../../hooks/useConsultation';
import Unit from '../Modular/Unit';
import Section from '../Modular/Section';
import Button from '../Button';
import { useClient } from '../../hooks/useClient';
import { useWindowSize } from '../../hooks/useWindowSize';

interface AdminConsultationProps {
  adminUserId?: string;
}

const Clients: React.FC<AdminConsultationProps> = ({ adminUserId }) => {
  const { fetchClientsByConsultant, loading } = useClient();
  const [clients, setClients] = React.useState<User[] | null>(null);

  const windowSize = useWindowSize();
  let gridStructure = windowSize.width < 780 ? 'column-1' : 'column-2';

  useEffect(() => {
    const fetchClients = async () => {
      let clients: User[] | null = null;

      if (adminUserId) {
        clients = await fetchClientsByConsultant(adminUserId);
        console.log('Fetched clients for admin:', clients);
      }
      if (clients) {
        setClients(clients);
      }
    };
    fetchClients();
  }, [adminUserId]);

  return (
    <>
      {clients && clients.length > 0 ? (
        clients.map((client) => (
          <div className="client-card">
            <Unit
              key={client.user_id}
              layout="flex"
              gap="sm"
              alignItems="center"
              paddingLeft="md"
              paddingRight="md"
              borderRadius="md"
              width="3"
              height="2"
            >
              <img alt={`${client.firstName} ${client.lastName}`} />
              <h3>{`${client.firstName} ${client.lastName}`}</h3>
            </Unit>
          </div>
        ))
      ) : (
        <p>No clients found.</p>
      )}
    </>
  );
};

export default Clients;
